import React from 'react';
import PropTypes from 'prop-types';

class Location extends React.PureComponent {
  render() {
    return (
      <h3 className="location">
        <a target="_blank noreferrer" href={`https://www.google.cl/maps/place/${encodeURI(this.props.address)}`}>
          <i className="fa fa-map-marker" />
          {this.props.text}
        </a>
      </h3>
    );
  }
}

Location.propTypes = {
  address: PropTypes.string,
  text: PropTypes.string,
};

Location.defaultProps = {
  address: '',
  text: '',
};

export default Location;



// WEBPACK FOOTER //
// ./src/components/Location/index.js